import { Box, Button, Modal as MuiModal } from '@mui/material';
import React from 'react';
import { useHistory } from 'react-router-dom';
import { useGetCmailMessage } from '../../console/cmail/CmailInbox/useGetCmailMessage';
import { CmailThreadedView } from '../../console/cmail/components/CmailDetailsResolver/CmailThreadedView';
import { usePersona } from '../hooks/usePersona';

interface CmailModalProps {
  open: boolean;
  onClose: () => void;
  msgId: string;
}

export const CmailModal: React.FC<CmailModalProps> = ({
  open,
  onClose,
  msgId,
}) => {
  const history = useHistory();
  // Only fetch when modal is open and msgId is provided
  const cmailMessageQuery = useGetCmailMessage(open && msgId ? msgId : '');
  const persona = usePersona();

  const handleOpenInCmailbox = () => {
    if (msgId) {
      history.push({
        pathname: '/admin/cmail',
        state: { msgId },
      });
    }
  };

  return (
    <MuiModal
      open={open}
      onClose={onClose}
      aria-labelledby="cmail-modal"
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <Box
        sx={{
          position: 'relative',
          width: '90%',
          maxWidth: '1000px',
          maxHeight: '90vh',
          bgcolor: 'background.paper',
          boxShadow: 24,
          p: 4,
          overflow: 'auto',
        }}
      >
        <Box
          sx={{
            position: 'absolute',
            top: 16,
            right: 30,
            zIndex: 1,
          }}
        >
          {persona.isCowbell && (
            <Button
              variant="contained"
              color="primary"
              onClick={handleOpenInCmailbox}
              sx={{ mr: 2 }}
            >
              Open in Concierge
            </Button>
          )}
          <Button variant="outlined" onClick={onClose}>
            Close
          </Button>
        </Box>
        <Box sx={{ pt: '2rem' }}>
          {cmailMessageQuery.isLoading && (
            <Box sx={{ textAlign: 'center', p: 4 }}>
              Loading email message...
            </Box>
          )}
          {cmailMessageQuery.isError && (
            <Box
              sx={{
                textAlign: 'center',
                p: 4,
                color: 'error.main',
              }}
            >
              Failed to load email message. Please try again or open in
              Concierge.
            </Box>
          )}
          {cmailMessageQuery.data && (
            <CmailThreadedView
              message={cmailMessageQuery.data}
              enrichedMessage={cmailMessageQuery.data}
            />
          )}
          {!cmailMessageQuery.isLoading &&
            !cmailMessageQuery.isError &&
            !cmailMessageQuery.data && (
              <Box sx={{ textAlign: 'center', p: 4 }}>
                No email message data available.
              </Box>
            )}
        </Box>
      </Box>
    </MuiModal>
  );
};
